
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/protected",
      function () {
        return require("private-next-pages/protected.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/protected"])
      });
    }
  